export const COMPOUND_FIELD_DEFINITIONS = [
  { compoundId: 1, key: "diaminoethaneDose", labelKey: "reports.diaminoethane_1_2" },
  {
    compoundId: 2,
    key: "amino2Methyl1PropanolDose",
    labelKey: "reports.amino_2_Methyl_1_Propanol_2",
  },
  {
    compoundId: 3,
    key: "methoxypropylamineDose",
    labelKey: "reports.methoxypropylamine_3",
  },
  { compoundId: 4, key: "aminopentanolDose", labelKey: "reports.aminopentanol_5" },
  { compoundId: 8, key: "ammoniaDose", labelKey: "ammonia" },
  { compoundId: 5, key: "cyclohexylamineDose", labelKey: "reports.cyclohexylamine" },
  { compoundId: 6, key: "ethanolamineDose", labelKey: "reports.ethanolamine" },
  { compoundId: 7, key: "morpholineDose", labelKey: "reports.morpholine" },
  { compoundId: 9, key: "hydrazineDose", labelKey: "reports.hydrazine" },
  { compoundId: 10, key: "crudIn", labelKey: "reports.crud" },
];

export const AMINE_COMPOUND_IDS = new Set([1, 2, 3, 4, 5, 6, 7, 8]);

export const HYDRAZINE_COMPOUND_ID = 9;
export const CRUD_COMPOUND_ID = 10;
export const TOTAL_AMINE_COMPOUND_ID = 11;

export const MEQ_FACTORS = {
  diaminoethaneDose: 2 / 60.1,
  amino2Methyl1PropanolDose: 1 / 89.14,
  methoxypropylamineDose: 1 / 89.14,
  aminopentanolDose: 1 / 103.16,
  ammoniaDose: 1 / 17.03,
  cyclohexylamineDose: 1 / 99.17,
  ethanolamineDose: 1 / 61.08,
  morpholineDose: 1 / 87.12,
  hydrazineDose: 2 / 32.05,
};

export const DOSE_RANGE = { hard: { min: 0, max: 100 } };

export const DEFAULT_CONDENSATE_POLISHING_DATA = COMPOUND_FIELD_DEFINITIONS.reduce((accumulator, field) => {
  accumulator[field.key] = 0;
  return accumulator;
}, {});
